/*
 * Wire
 * Copyright (C) 2016 Wire Swiss GmbH
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program. If not, see http://www.gnu.org/licenses/.
 *
 */

'use strict';

/**
 * @class BaseError
 * @extends Error
 * @param {string} message
 * @returns {string}
 */
module.exports = (function() {
  const BaseError = function(message) {
    this.name = this.constructor.name;
    this.message = message;
    this.stack = (new Error).stack;
  };

  BaseError.prototype = new Error;
  BaseError.prototype.constructor = BaseError;

  return BaseError;
})();



//////////////////
// WEBPACK FOOTER
// ./src/cbor/BaseError.js
// module id = 1
// module chunks = 0